<template>
    <div class="home">
        <!-- banner -->
        <!-- <section class="banner">
			<swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
				<swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index"><img :src="item.CoverStr" /></swiper-slide>
				<div class="swiper-pagination bannerSpan" slot="pagination"></div>
			</swiper>
		</section> -->

        <!-- neirong -->
        <section class="aiDiv">
            <img
                v-if="homePicture.FirstShow"
                v-lazy="homePicture.FirstPicture"
            />
            <img
                v-if="homePicture.SecondShow"
                v-lazy="homePicture.SecondPicture"
            />
            <img
                v-if="homePicture.ThirdShow"
                v-lazy="homePicture.ThirdPicture"
            />
            <img
                v-if="homePicture.FourShow"
                v-lazy="homePicture.FourPicture"
            />
            <img
                v-if="homePicture.FiveShow"
                v-lazy="homePicture.FivePicture"
            />
            <img
                v-if="homePicture.SixShow"
                v-lazy="homePicture.SixPicture"
            />
        </section>
        <article
            class="home_saas home-apply-con"
            v-if="sidebar.ShopId==0"
        >
            <img v-lazy="sidebar.BasePicture" />
            <div class="home-apply">
                <div class="home-apply-left">
                    <div class="apply-left-li">
                        <img src="../../image/bha.png" />
                        <p class="apply-left-c01">
                            <span v-if="sidebar.ShopId==0">咨询老师：{{sidebar.Name}}</span>
                            <span class="on-phone">{{sidebar.Phone}}</span>
                        </p>
                    </div>
                    <button
                        v-if="sidebar.ShopId==0"
                        @click="shenqingBtn"
                    >立即申请</button>
                </div>
                <div class="home-apply-right">
                    <img v-lazy="sidebar.WeChartImg" />
                    <!-- <span>直通车</span> -->
                </div>
            </div>
        </article>
        <!-- 联系客服 -->
        <aside-fixed></aside-fixed>
        <!-- 申请弹窗 -->
        <div
            class="popup"
            v-show="isShenqin"
        >
            <div class="serve-popup animated fadeIn">
                <div class="serve-pop-del">
                    <img
                        @click="closeApply"
                        src="../../image/vol-del-t.png"
                    />
                </div>
                <ul class="serve-pop-from">
                    <li>
                        <span>用户名</span>
                        <input
                            v-model="name"
                            placeholder="请输入用户名"
                        />
                    </li>
                    <li>
                        <span>电话</span>
                        <input
                            v-model="phone"
                            placeholder="请输入电话号码"
                        />
                    </li>
                    <li>
                        <span>验证码</span>
                        <input
                            class="li-inp"
                            v-model="code"
                            placeholder="请输入验证码"
                        />
                        <p
                            @click="GetCode()"
                            class="code-btn"
                        >
                            <span v-show="show">获取验证码</span>
                            <span
                                v-show="!show"
                                class="count"
                            >重新获取{{ count }}s</span>
                        </p>
                    </li>
                </ul>
                <button
                    class="serve-pop-btn"
                    v-on:click="SubmitSave"
                >提交</button>
            </div>
        </div>
    </div>
</template>

<script>
import asideFixed from '@/components/global/aside/aside.vue';
const TIME_COUNT = 60;
export default {
    components: {
        asideFixed
    },
    data() {
        return {
            bannerList: [],
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            homePicture: [],
            sidebar: {},
            // 倒计时
            show: true,
            count: '',
            timer: null,
            // 申请弹窗
            isShenqin: false,
            phone: '',
            name: '',
            code: '',
            backCode: '',
            isClick: false
        };
    },
    mounted() {
        this.GetNavigation();
        this.GetSidebar();
    },
    methods: {
        callback() { },
        // 申请
        shenqingBtn() {
            this.isShenqin = true;
        },
        // 关闭申请
        closeApply() {
            this.isShenqin = false;
        },
        // 倒计时
        backTime() {
            var that = this;
            if (!that.timer) {
                that.count = TIME_COUNT;
                that.show = false;
                that.timer = setInterval(() => {
                    if (that.count > 0 && that.count <= TIME_COUNT) {
                        that.count--;
                    } else {
                        that.show = true;
                        clearInterval(that.timer);
                        that.timer = null;
                    }
                }, 1000);
            }
        },
        // 获取图片
        GetNavigation: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetNavigationDetail?position=4',
                'GET', {},
                function (res) {
                    console.log('获取图片');
                    console.log(res);
                    if (res.code === 0) {
                        that.homePicture = res.data;
                    }
                },
                function (res) { }
            );
        },
        // 获取底图
        GetSidebar: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetSidebar',
                'GET', {},
                function (res) {
                    console.log('获取底图');
                    console.log(res);
                    if (res.code === 0) {
                        that.sidebar = res.data;
                    }
                },
                function (res) { }
            );
        },
        // 获取轮播图
        GetBanner: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetPagePicture',
                'GET', {},
                function (res) {
                    console.log('获取轮播图');
                    console.log(res);
                    if (res.code === 0) {
                        var list = res.data;
                        var newList = [];
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].Type === 1 && list[i].Position !== 4) {
                                newList.push(list[i]);
                            }
                        }
                        that.bannerList = newList;
                        that.swiper.slideTo(3, 1000, false);
                        console.log(newList);
                    }
                },
                function (res) { }
            );
        },

        // 获取验证码
        GetCode: function () {
            var that = this;
            if (that.count > 0) {
                return;
            }
            console.log(that.phone);
            if (that.phone.length === 0) {
                this.$util.showError('请输入手机号');
                return;
            } else if (!(/^1[3456789]\d{9}$/.test(that.phone))) {
                this.$util.showError('请输入合法手机号');
                return;
            }
            that.$api.HtppRequest(
                'Common/GetUserCode?type=3&phone=' + that.phone,
                'GET', {},
                function (res) {
                    console.log('获取验证码');
                    console.log(res);
                    if (res.flag) {
                        that.backCode = res.code;
                        that.backTime();
                    } else {
                        this.$util.showError(res.msg);
                    }
                },
                function (res) { }
            );
        },
        // 提交数据
        SubmitSave: function () {
            var that = this;
            if (that.isClick) {
                return;
            }
            that.isClick = true;
            if (that.phone.length === 0) {
                this.$util.showError('请输入手机号');
                that.isClick = false;
                return;
            } else if (!(/^1[3456789]\d{9}$/.test(that.phone))) {
                this.$util.showError('请输入合法手机号');
                that.isClick = false;
                return;
            }
            if (that.name.length === 0) {
                this.$util.showError('请输入用户名');
                return;
            }
            if (that.code.length === 0) {
                this.$util.showError('请输入验证码');
                that.isClick = false;
                return;
            }
            if (that.code !== that.backCode) {
                this.$util.showError('验证码错误');
                that.isClick = false;
                return;
            }
            that.$api.HtppRequest(
                'SystemData/AddUserConsultation?UserName=' + that.name + '&UserPhone=' + that.phone,
                'POST', {},
                function (res) {
                    console.log('提交数据');
                    console.log(res);
                    if (res.flag) {
                        that.$util.showOk('提交成功');
                        setTimeout(function () {
                            that.isClick = false;
                            that.closeApply();
                        }, 1000);
                    } else {
                        that.$util.showError(res.msg);
                        that.isClick = false;
                    }
                },
                function (res) {
                    that.isClick = false;
                }
            );
        }
    }
};
</script>
<style scoped>
/* serve-popup */
.serve-popup {
    width: 400px;
    height: 320px;
    overflow: hidden;
    background: #fff;
    border-radius: 5px;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 51;
    margin-top: -160px;
    margin-left: -200px;
}

.serve-pop-del {
    width: 100%;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.serve-pop-del img {
    width: 20px;
    height: 20px;
    display: block;
    cursor: pointer;
}

.serve-pop-from {
    width: 100%;
    padding: 0 30px;
    height: auto;
}

.serve-pop-from li {
    padding: 15px 0;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;
}

.serve-pop-from li > span {
    font-size: 14px;
    color: #666;
    display: block;
    width: 20%;
    text-align: left;
}

.serve-pop-from li input {
    font-size: 14px;
    color: #333;
}

.serve-pop-from li .li-inp {
    width: 40%;
}

.serve-pop-btn {
    width: 80%;
    font-size: 14px;
    color: #fff;
    background-color: #333;
    border-radius: 50px;
    height: 44px;
    line-height: 44px;
    display: block;
    margin: 25px auto 0 auto;
    cursor: pointer;
}

.code-btn {
    width: 40%;
    text-align: right;
    cursor: pointer;
}

.code-btn span {
    font-size: 14px;
    color: #333;
}

.serve-pop-from li input::-webkit-input-placeholder {
    color: #999;
}

.serve-pop-from li input:-moz-placeholder {
    color: #999;
}

.serve-pop-from li input:-ms-input-placeholder {
    color: #999;
}

/* home-apply-con */
.home-apply-con {
    position: relative;
    width: 1200px;
    margin: 0 auto;
}

.home-apply {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    height: auto;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 40px 0;
    margin-right: 40px;
    margin-bottom: 50px;
}

.home-apply-left {
    width: 280px;
    height: auto;
    border-right: 1px solid #1a657f;
}

.apply-left-li {
    display: flex;
    justify-content: center;
}

.apply-left-li > img {
    width: 32px;
    height: 32px;
    display: block;
    margin-right: 10px;
}

.apply-left-c01 {
    height: auto;
}

.apply-left-c01 span {
    width: 100%;
    display: block;
    font-size: 18px;
    color: #333;
}

.apply-left-c01 .on-phone {
    font-size: 22px;
}

.home-apply-left > button {
    width: 160px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    background: linear-gradient(to right, #f78c31, #ffa62a);
    border-radius: 50px;
    margin: 40px auto 0 auto;
    display: block;
    cursor: pointer;
}

.home-apply-right {
    width: 200px;
    height: auto;
}

.home-apply-right img {
    width: 130px;
    height: 130px;
    display: block;
    margin: 0 auto;
}

.home-apply-right span {
    font-size: 15px;
    color: #fff;
    text-align: center;
    display: block;
    width: 100%;
    margin-top: 10px;
}

.aiDiv {
    overflow: hidden;
    margin-bottom: 60px;
}

.aiDiv img {
    display: block;
    width: 100%;
}

/* home_mei */

.home_saas > img {
    display: block;
    width: 100%;
}

.home_saas {
    overflow: hidden;
}

/* home_saas */

.homeNei {
    overflow: hidden;
    width: 100%;
    margin: 0px auto;
}

/* homeNei */

* >>> .swiper-pagination-bullet {
    width: 20px !important;
    height: 10px !important;
    border-radius: 50px;
    background-color: rgba(255, 255, 255, 0.7);
}

* >>> .swiper-pagination-bullet-active {
    background-color: #fff;
}

.banner {
    overflow: hidden;
    height: auto;
    background: url(../../image/AI-banner.png) no-repeat left top;
    background-size: 1920px 700px;
}
</style>
